import React, { useContext } from 'react';
import { AppContext } from 'App.context';
import SubHeader from '../SubHeader/SubHeader';
import RoomsTable from './RoomsTable/RoomsTable';
import useSelectRoomsHook from './SelectRooms.hook';

export default function SelectRooms({ onNext }) {
  const {
    appActions: { getSelectedHotel },
  } = useContext(AppContext);
  const { state, actions } = useSelectRoomsHook({ onNext });
  const showNext = Boolean(state.rooms?.find(room => room.booked > 0));
  return (
    <>
      {state.rooms?.length && (
        <>
          <SubHeader hotelName={getSelectedHotel()?.name} showNext={showNext} onNext={onNext} />
          <RoomsTable rooms={state.rooms} onAddRoom={actions.onAddRoom} />
        </>
      )}
    </>
  );
}
